import script from "./BaseDoubleClickEditTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDoubleClickEditTextArea.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__